// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"319":"87f6f016","453":"fb5ab6dc","821":"e7b4467a"}[chunkId] + ".chunk.js");